module.exports = __webpack_public_path__ + "img/setting.102e5f0c.svg";